import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import ExchangeCalculator from './components/ExchangeCalculator';
import ExchangeHistory from './components/ExchangeHistory';
import ExchangeLocations from './components/ExchangeLocations';
import ExchangeTips from './components/ExchangeTips';
import Footer from '../../components/feature/Footer';
import { useSEO, generateWebPageSchema } from '../../utils/seo';

const PesoDollarExchangePage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [currentRate, setCurrentRate] = useState(19.85);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  // Simulate live exchange rate updates
  useEffect(() => {
    const updateRate = () => {
      // Simulate realistic exchange rate fluctuations
      const baseRate = 19.85;
      const fluctuation = (Math.random() - 0.5) * 0.2; // ±0.1 peso fluctuation
      const newRate = baseRate + fluctuation;
      setCurrentRate(Number(newRate.toFixed(4)));
      setLastUpdate(new Date());
    };

    // Initial update
    updateRate();

    // Update every 30 seconds
    const interval = setInterval(updateRate, 30000);
    
    return () => clearInterval(interval);
  }, []);

  useSEO({
    title: 'Peso Dollar Exchange Rate Today - Live USD/MXN Currency Converter Juárez',
    description: 'Get live peso dollar exchange rates in Ciudad Juárez. Real-time USD/MXN converter, best exchange locations, historical rates, and expert tips for currency exchange in Mexico.',
    keywords: 'peso dollar exchange rate, USD MXN, currency converter, exchange rate Juarez, peso exchange, dollar exchange Juarez',
    ogImage: 'https://static.readdy.ai/image/a7a45bef519addb86f62650fa4d00e15/75271c8b1fbc4fc61d97819f5d86a53b.jpeg',
    schema: generateWebPageSchema({
      name: 'Peso Dollar Exchange Rate Ciudad Juárez',
      description: 'Complete guide to peso dollar exchange rates in Ciudad Juárez with live rates, currency converter, and best exchange locations.'
    })
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-[1400px] mx-auto px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/a7a45bef519addb86f62650fa4d00e15/f12461d740e8c3a7e92fb8892e69dcde.png" 
              alt="JuarezMX Logo" 
              className="h-12 w-auto"
            />
          </Link>
          <div className="flex items-center gap-12">
            <Link to="/" className={`text-sm font-light tracking-wide transition-colors ${
              scrolled ? 'text-gray-800 hover:text-emerald-600' : 'text-white/90 hover:text-white'
            }`}>
              Home
            </Link>
            <Link to="/juarez-mexico-city-guide" className={`text-sm font-light tracking-wide transition-colors ${
              scrolled ? 'text-gray-800 hover:text-emerald-600' : 'text-white/90 hover:text-white'
            }`}>
              City Guide
            </Link>
            <Link to="/places-to-eat" className={`text-sm font-light tracking-wide transition-colors ${
              scrolled ? 'text-gray-800 hover:text-emerald-600' : 'text-white/90 hover:text-white'
            }`}>
              Dining
            </Link>
            <Link to="/attractions" className={`text-sm font-light tracking-wide transition-colors ${
              scrolled ? 'text-gray-800 hover:text-emerald-600' : 'text-white/90 hover:text-white'
            }`}>
              Attractions
            </Link>
            <Link to="/border-crossing-wait-times" className={`text-sm font-light tracking-wide transition-colors ${
              scrolled ? 'text-gray-800 hover:text-emerald-600' : 'text-white/90 hover:text-white'
            }`}>
              Bridges
            </Link>
          </div>
        </div>
      </nav>

      <Hero currentRate={currentRate} lastUpdate={lastUpdate} />
      <ExchangeCalculator currentRate={currentRate} />
      <ExchangeHistory />
      <ExchangeLocations />
      <ExchangeTips />
      <Footer />
    </div>
  );
};

export default PesoDollarExchangePage;